
import { createBrowserRouter } from 'react-router-dom';
import RootLayout from './RootLayout';
import {
    AdminWebinarAdd,
    AdminWebinarList,
    AdminWorkshopList,
    AdminSubscriptionPlans,
    AdminVideoClips,
    AdminHomepageHero,
    AdminImageGuidelines,
    AdminHomepageCarousels,
    AdminDoctors,
    AdminUsers,
    AboutUs,
    ContactUs,
    DiscussionAdd,
    DiscussionDetail,
    DiscussionList,
    Dashboard,
    DoctorList,
    EpisodeAdd,
    EpisodeEdit,
    Home,
    Login,
    NotFound,
    PaymentDetail,
    PaymentList,
    PrivacyAndPolicy,
    ProfileDetail,
    ProfileEdit,
    ProfileEditDoctor,
    PublicationAdd,
    PublicationDetail,
    PublicationEdit,
    PublicationList,
    TagDetail,
    Verify,
    VisitDoctor,
    VisitDoctorReserve,
    WebinarAdd,
    WebinarDetail,
    WebinarEdit,
    WebinarList,
    WebinarPurchase,
    WorkshopAdd,
    WorkshopDetail,
    WorkshopEdit,
    WorkshopList,
    WorkshopPurchase,
    SubscriptionList,
    VideoClipList,
    VideoClipDetail
} from '../pages';


export const router = createBrowserRouter([
    {
        element: <RootLayout />,
        children: [
    {
        path: '/',
        element: <Home />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/login/',
        element: <Login />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/verify/',
        element: <Verify />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/dashboard/',
        element: <Dashboard />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/dashboard/webinars/',
        element: <AdminWebinarList />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/dashboard/workshops/',
        element: <AdminWorkshopList />,
        errorElement: <NotFound />,
    },
    {
        path: '/dashboard/subscriptions/',
        element: <AdminSubscriptionPlans />,
        errorElement: <NotFound />,
    },
    {
        path: '/dashboard/video-clips/',
        element: <AdminVideoClips />,
        errorElement: <NotFound />,
    },
    {
        path: '/dashboard/homepage-hero/',
        element: <AdminHomepageHero />,
        errorElement: <NotFound />,
    },
    {
        path: '/dashboard/image-guidelines/',
        element: <AdminImageGuidelines />,
        errorElement: <NotFound />,
    },
    {
        path: '/dashboard/homepage-carousels/',
        element: <AdminHomepageCarousels />,
        errorElement: <NotFound />,
    },
    {
        path: '/dashboard/doctors/',
        element: <AdminDoctors />,
        errorElement: <NotFound />,
    },
    {
        path: '/dashboard/users/',
        element: <AdminUsers />,
        errorElement: <NotFound />,
    },
    {
        path: '/video_clips/',
        element: <VideoClipList />,
        errorElement: <NotFound />,
    },
    {
        path: '/video_clip_detail/:clipId/',
        element: <VideoClipDetail />,
        errorElement: <NotFound />,
    },
    {
        path: '/subscriptions/',
        element: <SubscriptionList />,
        errorElement: <NotFound />,
    },
    {
        path: '/tag/:tagId/',
        element: <TagDetail />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/profile/:profileId/',
        element: <ProfileDetail />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/profile_edit/',
        element: <ProfileEdit />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/profile_edit_doctor/',
        element: <ProfileEditDoctor />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/payment_list/',
        element: <PaymentList />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/payment_detail/:paymentId/',
        element: <PaymentDetail />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/discussion_list/',
        element: <DiscussionList />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/discussion_detail/:discussionId/',
        element: <DiscussionDetail />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/discussion_add/',
        element: <DiscussionAdd />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/publication_list/',
        element: <PublicationList />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/publication_detail/:publicationId/',
        element: <PublicationDetail />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/publication_add/',
        element: <PublicationAdd />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/publication_edit/:publicationId/',
        element: <PublicationEdit />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/doctor_list/',
        element: <DoctorList />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/visit_doctor/',
        element: <VisitDoctor />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/visit_doctor_reserve/:doctorId/',
        element: <VisitDoctorReserve />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/webinar_list/',
        element: <WebinarList />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/webinar_detail/:webinarId/',
        element: <WebinarDetail />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/webinar_add/',
        element: <WebinarAdd />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/admin_webinar_add/',
        element: <AdminWebinarAdd />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/webinar_edit/:webinarId/',
        element: <WebinarEdit />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/webinar_purchase/:webinarId/',
        element: <WebinarPurchase />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/workshop_list/',
        element: <WorkshopList />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/workshop_detail/:workshopId/',
        element: <WorkshopDetail />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/workshop_add/',
        element: <WorkshopAdd />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/workshop_edit/:workshopId/',
        element: <WorkshopEdit />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/workshop_purchase/:workshopId/',
        element: <WorkshopPurchase />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/episode_add/:workshopId/',
        element: <EpisodeAdd />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/episode_edit/:episodeId/',
        element: <EpisodeEdit />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/privacy_and_policy/',
        element: <PrivacyAndPolicy />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/about_us/',
        element: <AboutUs />,
        errorElement: (
            <NotFound />
        ),
    },
    {
        path: '/contact_us/',
        element: <ContactUs />,
        errorElement: (
            <NotFound />
        ),
    },
        ],
    },
]);
